import { makeObservable, action, observable, computed } from 'mobx'

interface Pagination {
  pageIndex: number;
  pageSize: number;
  total: number;
}
export class PagingStore {
  public pageIndex: number = 1;
  public pageSize: number = 10;
  public total: number = 0;
  public pageInfoChanged: boolean = false;
  public hooks: any;
  storeType: string = 'PagingStore';
  errorMessage: string
  // rootStore: any;

  constructor(datasource?: any, _rootStore?: any) {
    this.pageSize = datasource?.defaultPageSize || 10
    this.hooks = {}
    this.errorMessage = ''
    // this.rootStore = rootStore
    makeObservable(this, {
      pageIndex: observable,
      errorMessage: observable,
      pageSize: observable,
      pageInfoChanged: observable,
      total: observable,
      pageInfo: computed,
      setPageIndex: action.bound,
      previous: action.bound,
      next: action.bound,
      first: action.bound,
      last: action.bound,
      onChange: action.bound
    })
  }

  init() {
    this.total = 0,
    this.pageIndex = 1,
    this.pageSize = 10
  }

  get pageInfo() {
    return {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      total: this.total
    }
  }

  setPageIndex(index: number) {
    this.pageIndex = index;
    this.pageInfoChanged = false;
  }

  setPageSize(index: number) {
    this.pageSize = index;
    this.pageInfoChanged = false;
  }

  setPageTotal(num: number) {
    this.total = num;
    this.pageInfoChanged = false;
  }

  setPageInfo(pageInfo: object) {
    // 设置分页
    Object.assign(this, pageInfo)
    this.pageInfoChanged = false;
  }

  getPageInfo() {
    return this.pageInfo
  }

  previous() {
    // 前一页
    let idx = this.pageIndex - 1;
    if (idx < 0) {
      idx = 0;
    }
    this.setPageIndex(idx);
  }

  next() {
    // 后一页
    let idx = this.pageIndex + 1;
    if (idx >= this.total) {
      idx = this.total - 1;
    }
    this.setPageIndex(idx);
    this.pageInfoChanged = true;
  }

  get isFirst() {
    return this.pageIndex === 0
  }

  get isLast() {
    return this.pageIndex === Math.ceil(this.total / this.pageSize)
  }

  first() {

    this.setPageIndex(0);
  }

  last() {
    this.setPageIndex(this.total - 1);
  }

  async onChange(pageInfo: Pagination) {
    const check = this.hooks?.checkChange?.(pageInfo)
    if (check?.includes(true)) {
      this.errorMessage = check
      return
    }
    const newPageInfo = {} as Pagination;
    let pageIndex = pageInfo.pageIndex || this.pageIndex;
    if (this.pageSize !== pageInfo.pageSize) {
      pageIndex = 1;
    }
    newPageInfo.pageIndex = pageIndex
    newPageInfo.pageSize = pageInfo.pageSize || this.pageSize
    newPageInfo.total = pageInfo.total || this.total
    this.setPageInfo(newPageInfo)
    this.pageInfoChanged = true;
  }
}
